import auth from "../../services/auth";
import Contracts from "../../services/contracts";
import moment, { relativeTimeRounding } from "moment";
import ContractName from "./contract-name.vue";
import * as _ from "lodash";
import Sales from "../../services/sales";
import messageService, { Message } from "../../services/message";
import C from "../common/constantes";
import { cents } from "../../filters/number";
import * as F from "../../filters/date";
import { mapMutations } from "vuex";
import { beforeOneYear } from "../../validators/date";
import Tolls from "../../services/toll";
import Account from "../../services/account";
import Tag from "../../services/tag";
import Vehicles from "../../services/vehicles";
import Auth from "../../services/auth";
import Accordion from "../../components/accordion/accordion.vue";
import ModalAutomatic from "./contract/modal-automatic-value.vue";
import ModalRecharge from "./contract/modal-change-automatic-value.vue";
import messageDialog from "../../components/message-dialog.vue";
import modalTransfer from "../../components/modal-transfer.vue";
import ModalAggregate from "./aggregate/modal/modal-aggregate-register.vue";
import ModalTollTicket from "./aggregate/modal/modal-toll-ticket.vue";
import ModalRescueBalance from "./aggregate/modal/modal-rescue-balance.vue";
import ModalPrintVp from "./aggregate/modal/modal-print-vp.vue";
import ModalBlockVehicle from "./aggregate/modal/modal-block-vehicle.vue";
import ModalRouteVp from "./aggregate/modal/modal-route-vp.vue";
import ModalReceiptVp from "./aggregate/modal/modal-receipt-vp.vue";
import PaginationSm, { PageSm } from "../../components/pagination-sm";

import modalMyContracts from "../../components/modal-my-contracts.vue";
import sales from "../../services/sales";

const RECHARGE_UNIT_VALUE = 50.0;

const texts = {
  partialBlocked: "",
};

export default {
  data() {
    return {
      newAhesionTax: undefined,
      newVehicleTax: undefined,
      canMigratePlan: false,
      currentBalance: undefined,
      contracts: [],
      vpSelected: undefined,
      state: undefined,
      newMoveMaisId: undefined,
      invoices: new Map(),
      loading: undefined,
      modalRecharge: {},
      vp: undefined,
      embarcadorVpPre: undefined,
      embarcadorVpPos: undefined,
      aggregateVehicles: undefined,
      showLabSodreModal: false,
      checkVehicle: false,
      tagReservaSaldoByContract: {},
      valorDebitado: "",
      erroDebito: undefined,
      cobrarDebito: [],
      numeroCartao: undefined,
      primeiroCartao: false,
      msgErro: undefined,
      hasRodosol: false,
      contractSelected: undefined,
      vpFilterDate: {},
      typeAggregate: undefined,
      dataAggregate: {},
      rescueData: undefined,
      showRescue: false,
      showBlock: false,
      showModalAggregate: false,
      showModalTollTicket: false,
      showPrintVp: false,
      showRouteVp: false,
      showReceiptVp: false,
      contractAggregate: undefined,
      contractIdAggregate: undefined,
      contractShipper: undefined,
      partialBlockedMessage: "",
      open: true,
      loadingVehiclesAggregate: false,
      lang: {
        formatLocale: {
          months: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ],
          monthsShort: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Maio",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
          ],
          weekdays: [
            "Domingo",
            "Segunda-feira",
            "Terça-feira",
            "Quarta-feira",
            "Quinta-feira",
            "Sexta-feira",
            "Sábado",
          ],
          weekdaysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
          weekdaysMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
          firstDayOfWeek: 0,
          firstWeekContainsDate: 1,
        },
      },
      momentFormat: {
        stringify: (date) => {
          return date ? moment(date).format("L") : "";
        },
      },
      lastDays: "31",
      customStart: undefined,
      customEnd: undefined,
      dateRange: [this.customStart, this.customEnd],
      pageSm: new PageSm(),
      pageSmVpPre: new PageSm(),
      pageSmVpPos: new PageSm(),
      contractIdVpPre: undefined,
      contractIdVpPos: undefined,
      totalVps: 0,
      totalVpExpired: 0,
      show: {
        toll_ticket: false,
      },
      promises: [],
      checkMigration: undefined,
      showModalMyContracts: false,
      svgContent: "",
      svgContentMobile: "",
      parceiroUrlId: undefined,
      urlDestino: undefined,
      isMobile: undefined,
      loadingPaymentMethods: {},
    };
  },

  watch: {
    contracts: {
      handler: function (val, oldVal) {
        this.checkValidContract();
        let contract = this.contracts[0];
        if (contract && contract.summary) {
          let valueTaxAllVehicle =
            this.newVehicleTax * contract.summary.cadastrados;

          this.canMigratePlan =
            valueTaxAllVehicle > contract.currentBalance.currentBalance
              ? false
              : true;
        }
      },
      deep: true,
    },

    $route: function () {
      this.promises.push(
        this.findContracts(this.$route.Query.moveMaisId).then(() => {
          this.checkMigrationStatus();
        }),
      );
    },

    promises(val) {
      this.loading = Promise.all(val);
    },
  },

  created() {
    window.addEventListener("scroll", () => {
      this.isScrolling = window.scrollY > 0;
    });

    this.setIsMobile();

    this.$watch("isMobile", (newValue, oldValue) => {
      if (newValue !== oldValue) {
        this.onMobileChange(newValue);
      }
    });

    window.addEventListener("resize", this.setIsMobile);
  },

  mounted() {
    this.getMessage();

    this.getBannersParceiro();

    this.checkValidContract();

    sessionStorage.removeItem("promoCheck");
    $('[data-toggle="tooltip"]').tooltip();

    let filter = {
      moveMaisIdDest: this.currentUser.moveMaisId,
      page: this.pageSm.build(),
    };

    this.promises.push(
      Tolls.getFilterLimited(filter).then((data) => {
        if (data && data.itens && data.itens.length) this.vp = data.itens;
      }),
    );

    this.promises.push(
      this.findContracts(this.currentUser.moveMaisId).then((response) => {}),
    );

    this.checkMigrationStatus();
  },
  computed: {
    currentUser() {
      return auth.currentUser;
    },
    possuiTagReserva() {
      return !!(auth.currentUser && auth.currentUser.possuiTagReserva);
    },
    formatDate(date) {
      return moment(date).format("L");
    },
    localeFilterDate() {},
    clientCellPhone() {
      return this.currentUser.dddCellphone + this.currentUser.nroCellphone;
    },
    clientName() {
      if (this.currentUser.person) {
        return (
          this.currentUser.person.name.replace(" ", "_") +
          "_" +
          this.currentUser.person.lastName.replace(" ", "_")
        );
      } else {
        return this.currentUser.company.companyName.replace(/ /g, "_");
      }
    },
    bannerImageLink() {
      if (
        window.document.webview ||
        window.screen.width <= 600 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      ) {
        return "/static/sodre/BANNER_SITE_MOBILE-combotao335.png";
      }
      return "/static/sodre/DESKTOP-CERTO-COM-BOTÃO.png";
    },
    labSodrePromotionLink() {
      return "https://sodretox.com.br/exame-toxicologico/comprar/rede-credenciada/moveMaisHome";
    },
    periodStart() {
      let days = this.lastDays;
      let d =
        this.customStart != undefined && this.customStart != null
          ? moment(this.customStart)
          : moment().subtract(parseInt(days), "d");

      return F.date(d, "YYYY-MM-DD");
    },

    /** Calcula a data final do relatório **/
    periodEnd() {
      let days = this.lastDays;
      let d =
        this.customEnd != undefined && this.customEnd != null
          ? moment(this.customEnd)
          : moment();

      return F.date(d, "YYYY-MM-DD");
    },
  },

  filters: {
    formatPlate(placa) {
      return `${placa.substr(0, 3)}-${placa.substr(3, 7)}`;
    },
  },

  methods: {
    openPaymentMethods(contractId) {
      this.$set(this.loadingPaymentMethods, contractId, true);
      sales
        .redirectToContractPayment(contractId)
        .catch(() => {})
        .finally(() => {
          this.$set(this.loadingPaymentMethods, contractId, false);
        });
    },

    setIsMobile() {
      this.isMobile = window.innerWidth <= 769;
    },

    getBannersParceiro() {
      sales
        .getBannersParceiro()
        .then((res) => {
          const banners = res && res.banners ? res.banners : {};
          this.svgContent =
            banners.web && banners.web.svg ? banners.web.svg : "";
          this.svgContentMobile =
            banners.mobile && banners.mobile.svg ? banners.mobile.svg : "";
          this.parceiroUrlId = res ? res.parceiroUrlId : undefined;
          this.urlDestino = res ? res.urlDestino : undefined;
        })
        .catch((err) => {
          this.svgContent = "";
          this.svgContentMobile = "";
          console.error("erro no getBannersParceiro:", err);
        });
    },

    onPartnerBannerClick(dispositivo) {
      if (!this.urlDestino) {
        return;
      }

      if (
        this.parceiroUrlId &&
        this.currentUser &&
        this.currentUser.moveMaisId
      ) {
        sales
          .getBannerAccess({
            parceiroUrlId: this.parceiroUrlId,
            moveMaisId: this.currentUser.moveMaisId,
            dispositivo: (dispositivo || "").toUpperCase(),
          })
          .catch(() => {});
      }

      window.open(this.urlDestino, "_blank", "noopener,noreferrer");
    },

    onMobileChange() {},

    openMyContractsModal() {
      this.showModalMyContracts = true;
    },
    fecharModal() {
      this.showModalMyContracts = false;
    },
    checkValidContract() {
      let findContract = this.contracts.find(
        (contract) => contract.plan.planId == 62 || contract.plan.planId == 64,
      );
      if (findContract && findContract.status.contractStatusId == 0) {
        this.checkVehicle = false;
      }
    },
    zapay_inicio() {
      Sales.gravaLogRedirecionamentoBanner(
        this.currentUser.moveMaisId,
        2,
        1,
      ).then((res) => {});

      const url = `https://www.zignet.com.br/parceiro/movemais-interno/`;
      window.open(url, "_blank");
    },

    cancelarVP(idIntern, placaVeiculo, embarcador) {
      let vm = this;
      messageDialog
        .show({
          title: "Cancelar vale-pedágio",
          message: "Deseja cancelar o vale-pedágio?",
          type: "OK-CANCEL-ADHESION",
        })
        .then((res) => {
          if (res == "OK") {
            window.setTimeout(function () {
              vm.doCancel(idIntern, placaVeiculo, embarcador);
            }, 500);
          }
        });
    },

    checkMigrationStatus() {
      Contracts.checkStatusMigration(this.currentUser.moveMaisId).then(
        (response) => {
          this.checkMigration = response.listCheck;
        },
      );
    },

    doCancel(idIntern, placaVeiculo, embarcador) {
      let vm = this;
      let promise = Tolls.cancelar({ idIntern, placaVeiculo })
        .then((res) => {
          if (embarcador == "pre") {
            this.doFilterVpPre();
          } else {
            this.doFilterVpPos();
          }
        })
        .catch((err) => {
          vm.$nextTick(() => {
            return messageDialog.show({
              title: "Falha ao cancelar",
              message: err.data.status.message,
              type: "OK",
            });
          });
        });
      this.$store.dispatch("loading", promise);
      return promise;
    },

    ...mapMutations([
      "hasPlanEmbarcador",
      "setContracts",
      "setContractSelected",
    ]),
    showModalTransfer() {
      $("#modal-transfer").modal("show");
      $("#someTab").tab("show");
    },
    findContracts(moveMaisId) {
      /*Alterar para buscar do store, nesta tela sempre deve ir no servico (sem cache) */
      this.state = "LOADING";

      Tag.getTagReservaContexto().then((ctx) => {
        this.tagReservaSaldoByContract = ctx.cnpjPossuiEstoque
          ? ctx.saldoLiquidoByContract
          : {};
      });

      return Contracts.findAllContractsVw(moveMaisId)
        .then((contracts) => {
          this.contracts = contracts;
          this.state = "LOADED";
          let embarcador = _.find(contracts, (o) => {
            return this.getKindPlan(o.plan.planId) == "EMBARCADOR";
          });
          this.hasPlanEmbarcador(!!embarcador);

          if (this.contracts && this.contracts.length > 0) {
            _.find(this.contracts, (o) => {
              if (o.plan.planId == 62 || o.plan.planId == 64) {
                this.hasRodosol = true;
                this.contractSelected = o;
                this.setContractSelected(this.contractSelected);
                this.currentBalance = o.currentBalance.currentBalance;

                let newPlanId;
                if (o.plan.planId == 62) {
                  o.plan.newPlanId = 22;
                } else if (o.plan.planId == 64) {
                  o.plan.newPlanId = 32;
                }
                this.contractSelected = o;

                this.loading = Sales.getPlanById(o.plan.newPlanId)
                  .then((resp) => {
                    this.newAhesionTax = this.newVehicleTax = _.filter(
                      resp.adhesionTax.adhesionTax,
                      (o) => {
                        return o.taxId == C.NEW_VEHICLE_TAXID;
                      },
                    )[0].value;
                  })
                  .catch((err) => {});
              }
            });

            _.forEach(this.contracts, (o) => {
              this.$set(o, "open", false);
              if (o.planId != 7) {
                Contracts.getSummaryVehicles(o.contractId).then((r) => {
                  this.$set(o, "summary", r);
                });
              }

              Vehicles.getVehicleByContractIdContagem(o.contractId).then(
                (res) => {
                  this.numeroDeVeiculos = res.length;

                  if (
                    this.numeroDeVeiculos >= 10 &&
                    (o.plan.planId == 70 || o.plan.planId == 71)
                  ) {
                    this.bloqueiaRoadcard = true;
                  }
                },
              );
            });

            this.contractShipper = _.find(this.contracts, (o) => {
              return o.plan.planId == 6 || o.plan.planId == 8;
            });

            _.find(this.contracts, (o) => {
              if (o.plan.planId == 45 || o.plan.planId == 46) {
                this.contractIdAggregate = o.contractId;
                this.doFilter();
              }
              if (o.plan.planId == 6) {
                this.contractIdVpPre = o.contractId;
                this.doFilterVpPre();
              }
              if (o.plan.planId == 8) {
                this.contractIdVpPos = o.contractId;
                this.doFilterVpPos();
              }
            });
          }

          this.setContracts(contracts);
          return contracts;
        })
        .then((contracts) => {
          if (contracts.length == 0) {
            this.$router.push({ name: "new-contract" });
            return;
          }

          _.forEach(contracts, (c) => {
            Contracts.getPaymentMethod(c.contractId).then((resp) => {
              let algumUsuarioNulo = false;

              resp.forEach((item) => {
                if (
                  item.usuario === null &&
                  item.deleted != "Y" &&
                  item.validado != 1 &&
                  item.validado != -1
                ) {
                  algumUsuarioNulo = true;

                  if (
                    this.contracts.length === 1 &&
                    resp.length === 1 &&
                    item.validado === 0
                  ) {
                    this.primeiroCartao = true;
                  }
                  let validar = _.find(resp, (o) => o.validado === 0);
                  if (validar) {
                    if (!this.numeroCartao) {
                      this.numeroCartao = validar.number;
                    }
                    this.cobrarDebito.push(validar);
                    $("#valor-debitado").modal();
                  }
                }
              });
            });
          });

          if (contracts.length == 1) {
            let c = contracts[0];
            /*caso o status do contrato seja aguardando ativacao
            e o status do pedido é pagamento nao autorizado
            envia para a tela detalhes do pedido
          */
            this.currentUser.onlyOneContract = c.contractId;
            this.$store.commit("currentPlanId", c.plan.planId);
            auth.updateLocalStorage();
            if (
              c.status.contractStatusId === 0 &&
              !sessionStorage.getItem("showed-reprocess")
            ) {
              return Sales.listSalesOrders({
                moveMaisId: this.currentUser.moveMaisId,
              }).then((result) => {
                let pedidoAdesao = _.filter(
                  result.itens,
                  (o) => o.salesType == "ADHESION",
                );
                if (pedidoAdesao && pedidoAdesao.length == 1) {
                  if (
                    pedidoAdesao[0].salesOrderStatus.salesOrderStatusId == 3
                  ) {
                    sessionStorage.setItem("showed-reprocess", true);
                    this.$router.push({
                      name: "reprocess-order",
                      params: { orderId: pedidoAdesao[0].salesOrderId },
                    });
                    return Promise.reject("Pagamento não aprovado");
                  }
                }
              });
            }
          }
          if (this.isLabSodrePromotionPlan()) {
            this.showLabSodreModal = true;
          }

          let embarcador = _.find(contracts, (o) => {
            return o.plan.planId == 6 || o.plan.planId == 8;
          });

          let contratosLiberados = _.find(contracts, (o) => {
            return o.plan.typePlan == "PRE";
          });
          if (contratosLiberados) {
            Contracts.getContractData(this.currentUser.moveMaisId).then(
              (res) => {
                if (res.status.code == 0) {
                  this.checkVehicle = true;
                } else {
                  this.checkVehicle = false;
                }
              },
            );
          }

          if (!contratosLiberados) {
            Vehicles.checkVehicleByMoveMaisId(this.currentUser.moveMaisId).then(
              (res) => {
                this.checkVehicle = res.checkVehicle;

                if (this.checkVehicle == false) {
                  $("#info-block").modal();
                }
              },
            );
          }
          return contracts;
        })
        .then(this.getLastInvoice);
    },
    getLastInvoice(contracts) {
      _.each(contracts, (o) => {
        if (getKindPlan(o.plan.planId) == "POS_PAGO") {
          Contracts.getListInvoice(o.contractId).then((resp) => {
            if (resp.length > 0) this.invoices.set(o.contractId, resp[0]);
            this.$forceUpdate();
          });
        }
      });
    },

    getDueDate(contract) {
      if (this.invoices.get(contract.contractId)) {
        return this.invoices.get(contract.contractId).invoiceExpirationDate;
      }
      return "-";
    },

    getInvoiceValue(contract) {
      if (this.invoices.get(contract.contractId)) {
        return this.invoices.get(contract.contractId).value;
      }
      return "-";
    },

    getBillingDates(contract) {
      let b = contract.billingDay;
      if (contract.billingDay2) b += ", " + contract.billingDay2;
      if (contract.billingDay3) b += ", " + contract.billingDay3;
      return b;
    },

    getRechargePercent(contract) {
      let nom =
        contract.currentBalance && contract.currentBalance.currentBalance;
      let den = contract.rechargeValue;
      return Math.round(Math.min(Math.max(0, nom / den), 1) * 100);
    },

    getRechargeStyle(contract) {
      let width = Math.max(Math.round(this.getRechargePercent(contract)), 1);
      return `width: ${width}%`;
    },

    getRechargeClass(contract) {
      let per = this.getRechargePercent(contract) / 100;
      let trigger = this.getPercentRechargeAut(contract.plan.planId) / 100;
      if (per <= trigger) {
        return "progress-bar-danger";
      } else if (per < 0.6) {
        return "progress-bar-warning";
      } else {
        return "progress-bar-success";
      }
    },
    getContractName(contract) {
      if (contract.name) return contract.name;
      else return contract.contractId + " " + contract.plan.name;
    },
    showMessageContract() {
      messageDialog.show({
        title: "Info",
        headerClass: "modal-info",
        message: "Operação disponivel somente para contratos ativos",
      });
    },

    showMessage() {
      messageDialog.show({
        type: "CLOSE",
        title: "Contrato bloqueado parcialmente",
        message: this.partialBlockedMessage,
        headerClass: "modal-warning",
        showContactText: true,
      });
    },

    getCurrentBalance(c) {
      return cents(c.currentBalance.currentBalance);
    },

    getAutomaticRechargeValue(c) {
      return c.rechargeValue;
    },

    openModalRecharge(contractId) {
      this.$set(this.modalRecharge, contractId, true);
    },

    closeModalRecharge(contractId) {
      this.$set(this.modalRecharge, contractId, false);
    },

    isLabSodrePromotionPlan() {
      if (!this.$route.query.showPromotionalModal) {
        this.showLabSodreModal = false;
        return;
      }
      var plans = [21, 22, 31, 32, 45, 55];
      if (this.contracts.length > 0) {
        for (var c in this.contracts) {
          if (plans.includes(this.contracts[c].plan.planId)) {
            this.showLabSodreModal = true;
            return;
          }
        }
      }
    },
    getStatusClass(contract) {
      if (Number(contract.isEntryBlocked) === 999) return "";
      if (contract.status.name === "ATIVO") return "";
      return "status-red";
    },

    getStatusDotsClass(contract) {
      if (Number(contract.isEntryBlocked) === 999) return "status-pending";
      if (contract.status.name === "ATIVO") return "status-active";
      return "status-inactive";
    },

    getStatusContrato(status, isEntryBlocked) {
      if (Number(isEntryBlocked) === 999) {
        return texts.partialBlocked;
      }

      if (
        status.contractStatusId == 4 ||
        status.contractStatusId == 7 ||
        status.contractStatusId == 8 ||
        status.contractStatusId == 6
      ) {
        return "Bloqueado";
      } else {
        return status.name;
      }
    },

    getMobileStatusName(contract) {
      if (Number(contract.isEntryBlocked) === 999) return texts.partialBlocked;

      return contract.status.name;
    },

    bloqueiaFuncionalidades(status) {
      if (
        status != 0 &&
        status != 2 &&
        status != 3 &&
        status != 4 &&
        status != 6 &&
        status != 7 &&
        status != 8
      ) {
        return true;
      } else return false;
    },
    handleChangeDate(value) {
      if (value.length > 1) {
        this.customStart = value[0];
        this.customEnd = value[1];
        this.lastDays = undefined;
      } else {
        this.customStart = undefined;
        this.customEnd = undefined;
        this.lastDays = value;
      }
      this.doFilter(true);
    },
    rescueBalance(value) {
      this.showRescue = true;
      this.rescueData = value;
      this.$nextTick(() => {
        $("#modal-rescue-balance").modal();
      });
    },
    modalAggregate(value) {
      this.contractAggregate = value;
      this.contractAggregate.moveMaisId = this.currentUser.moveMaisId;
      this.showModalAggregate = true;
      this.$nextTick(() => {
        $("#modal-aggregate").modal({ backdrop: "static", keyboard: false });
      });
    },
    modalTollTicket() {
      this.contractShipper.moveMaisId = this.currentUser.moveMaisId;
      this.showModalTollTicket = true;
      this.$nextTick(() => {
        $("#modal-toll-ticket").modal();
      });
    },
    modalPrintVp(vp) {
      this.vpSelected = vp;
      this.showPrintVp = true;
      this.$nextTick(() => {
        $("#modal-print-vp").modal();
      });
    },
    modalRouteVp(contractId, idVP) {
      this.vpData = {
        contractId: contractId,
        idVP: idVP,
      };
      this.showRouteVp = true;
      this.$nextTick(() => {
        $("#modal-route-vp").modal();
      });
    },
    modalBlock(value) {
      this.showBlock = true;
      this.vpSelected = value;
      this.vpSelected.moveMaisId = this.currentUser.moveMaisId;
      this.$nextTick(() => {
        $("#modal-block-vehicle").modal();
      });
    },
    modalReceiptVp(contractId, idVP) {
      this.vpData = {
        contractId: contractId,
        idVP: idVP,
      };
      this.showReceiptVp = true;
      this.$nextTick(() => {
        $("#modal-receipt-vp").modal();
      });
    },
    close(filter) {
      switch (filter.modal) {
        case "toll-ticket":
          this.showModalTollTicket = false;
          this.doFilter(true);
          break;
        case "rescue-balance":
          this.showRescue = false;
          this.doFilter(true);
          break;
        case "route-vp":
          this.showRouteVp = false;
          this.vpData = undefined;
          break;
        case "print-vp":
          this.showPrintVp = false;
          break;
        case "aggregate":
          this.showModalAggregate = false;
          this.doFilter(true);
          break;
        case "receipt-vp":
          this.showReceiptVp = false;
          this.vpData = undefined;
          break;
        case "block-vehicle":
          this.showBlock = false;
          this.vpSelected = undefined;
          this.type = undefined;
          if (filter.state == "ok") {
            this.doFilter(true);
          }
          break;
      }

      this.$nextTick(() => {
        $("#modal-" + filter.modal).modal("hide");
      });
    },
    setCurrentPageVpPre(p) {
      this.pageSmVpPre = this.pageSmVpPre.page(p);
      this.doFilterVpPre();
    },
    setCurrentPageVpPos(p) {
      this.pageSmVpPos = this.pageSmVpPos.page(p);
      this.doFilterVpPos();
    },
    setCurrentPage(p) {
      this.pageSm = this.pageSm.page(p);
      this.doFilter();
    },
    setPageSize(size) {
      this.pageSm = this.pageSm.size(size);
      this.doFilter();
    },
    showUnblock(vehicle) {
      if (vehicle.reasonId == 8) return true;

      return false;
    },
    doFilter(clearCache) {
      if (this.contractIdAggregate) {
        let filterVP = {
          contractIdAgr: this.contractIdAggregate,
          page: this.pageSm.build(),
        };

        if (clearCache) {
          this.aggregateVehicles = {};
          filterVP.page = 1;
          this.pageSm = filterVP.page = this.pageSm.page(1);
        }

        if (filterVP) {
          this.loadingVehiclesAggregate = true;
          Vehicles.getVehiclesAggregate(filterVP)
            .then((data) => {
              this.aggregateVehicles = data.itens;
              _.forEach(this.aggregateVehicles, (o) => {
                this.$set(o, "open", false);
              });

              if (data.total && this.aggregateVehicles.length > 0) {
                this.searchState = "FOUND";
                this.pageSm = this.pageSm.itemCount(data.total);
              } else {
                this.searchState = "NOTFOUND";
              }
            })
            .catch((err) => {
              this.searchState = "NOTFOUND";
            })
            .finally(() => {
              this.loadingVehiclesAggregate = false;
            });
        }
      }
    },
    doFilterVpPre(clearCache) {
      let filterVP = {
        contratoOrig: this.contractIdVpPre,
        page: this.pageSmVpPre.build(),
      };

      if (clearCache) {
        this.embarcadorVpPre = {};
        filterVP.page = 1;
        this.pageSmVpPre = filterVP.page = this.pageSmVpPre.page(1);
      }
      Tolls.getFilterLimited(filterVP)
        .then((data) => {
          this.embarcadorVpPre = data.itens;

          if (data.total && this.embarcadorVpPre.length > 0) {
            this.searchState = "FOUND";
            this.pageSmVpPre = this.pageSmVpPre.itemCount(data.total);
          } else {
            this.searchState = "NOTFOUND";
          }
        })
        .catch((err) => {
          this.searchState = "NOTFOUND";
        });
    },
    doFilterVpPos(clearCache) {
      let filterVP = {
        contratoOrig: this.contractIdVpPos,
        page: this.pageSmVpPos.build(),
      };

      if (clearCache) {
        this.embarcadorVpPos = {};
        filterVP.page = 1;
        this.pageSmVpPos = filterVP.page = this.pageSmVpPos.page(1);
      }
      Tolls.getFilterLimited(filterVP)
        .then((data) => {
          this.embarcadorVpPos = data.itens;

          if (data.total && this.embarcadorVpPos.length > 0) {
            this.searchState = "FOUND";
            this.pageSmVpPos = this.pageSmVpPos.itemCount(data.total);
          } else {
            this.searchState = "NOTFOUND";
          }
        })
        .catch((err) => {
          this.searchState = "NOTFOUND";
        });
    },

    async getMessage() {
      const data = await messageService.getMessage(
        Message.type.BLOQUEADO_PARCIALMENTE,
      );
      this.partialBlockedMessage = data.message;
    },

    getTooltipText(contract) {
      if (Number(contract.isEntryBlocked) === 999)
        return this.partialBlockedMessage;
    },

    confirmCard() {
      var valor = this.valorDebitado.replace(/[^0-9]*/g, "");
      if (valor == 100) {
        return messageDialog
          .show({
            title: "Info",
            headerClass: "modal-info",
            message: "Valor cobrado deve ser entre 1,01 e 1,99",
          })
          .then((r) => {
            this.valorDebitado = null;
            $("#valor-debitado").modal();
          });
      }
      if (this.valorDebitado) {
        messageDialog
          .show({
            title: "Info",
            headerClass: "modal-info",
            type: "YES-NO",
            message:
              "Tem certeza que o valor debitado foi " +
              this.valorDebitado +
              "?",
          })
          .then((e) => {
            if (e == "YES") {
              let req = {
                chargeValue: valor,
                contractPaymentMethodId:
                  this.cobrarDebito[0].contractPaymentMethodId,
              };
              Sales.checkChargeValue(req)
                .then((resp) => {
                  let validaValor = resp.code;
                  if (validaValor == 0) {
                    $("#contrato-ativado").modal();
                  }
                  if (this.cobrarDebito[0]) {
                    this.numeroCartao = this.cobrarDebito[0].number;
                  }
                  this.cobrarDebito.shift();
                  this.valorDebitado = null;
                  if (this.cobrarDebito.length > 0) {
                    $("#valor-debitado").modal();
                  }
                })
                .catch((erro) => {
                  let error = erro.data.status.code;
                  var salesOrder = erro.data.salesOrder;
                  if (error == 1) {
                    if (this.primeiroCartao) {
                      this.erroDebito = 2;
                      $("#info-block").modal("hide");
                    } else {
                      this.erroDebito = 1;
                      if (salesOrder.salesOrderId) {
                        this.msgErro =
                          "Valor informado incorreto, pedido " +
                          salesOrder.salesOrderId +
                          " será cancelado.";
                      } else
                        this.msgErro =
                          "Valor informado incorreto, cartão cadastrado cancelado.";
                    }
                  } else if (error == 2) {
                    if (this.primeiroCartao) {
                      this.erroDebito = 1;
                      this.msgErro =
                        "O prazo de validação do cartão expirou. Favor realizar um novo cadastro.";
                      $("#info-block").modal("hide");
                    } else {
                      this.erroDebito = 1;
                      this.msgErro =
                        "O prazo de validação do cartão expirou. Favor realizar um novo cadastro.";
                    }
                  } else if (error == 3) {
                    this.erroDebito = 1;
                    this.msgErro =
                      "O prazo de validação do cartão expirou. Favor realizar um novo pedido.";
                  } else {
                    this.erroDebito = 1;
                    if (erro.data.status.message) {
                      this.msgErro = erro.data.status.message;
                    } else
                      this.msgErro =
                        "Erro ao validar, favor entrar em contato com a CR!";
                  }
                  $("#erro-debito").modal();
                });
            } else $("#valor-debitado").modal();
          });
      } else {
        messageDialog
          .show({
            title: "Info",
            headerClass: "modal-info",
            message: "Por favor digite um valor numerico valido",
          })
          .then((r) => {
            this.valorDebitado = null;
            $("#valor-debitado").modal();
          });
      }
    },

    confirmaErro() {
      if (this.erroDebito == 2) {
        Auth.logout().then(() => this.$router.push("/login"));
      }
      this.erroDebito = 0;
    },
  },

  components: {
    Accordion,
    ContractName,
    ModalRecharge,
    ModalAutomatic,
    modalTransfer,
    PaginationSm,
    ModalAggregate,
    ModalTollTicket,
    ModalRescueBalance,
    ModalPrintVp,
    ModalBlockVehicle,
    ModalRouteVp,
    ModalReceiptVp,
    modalMyContracts,
  },
};



// WEBPACK FOOTER //
// ./src/pages/account/plans.js